import { useState } from 'react';

export default function PartnershipSession() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5v8f49r44f5krorl490', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-10 md:p-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Partnership Clarity Session
          </h2>
          
          <p className="text-xl text-gray-700 mb-8">
            90 minutes to clarify your signal and create a 30-day action plan
          </p>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-10">
            <p>
              This is a co-creation session where we turn on the magnets and see what wants to unfold. The work is intuitive, strategic, and grounded.
            </p>
            
            <p>
              Through sessions like these, bestselling books have been born, unlikely partnerships have formed, and Oscar nominations have emerged. Not because we chased outcomes, but because alignment created momentum.
            </p>
            
            <div className="bg-amber-50 rounded-lg p-6 my-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">What's Included:</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-amber-600 mr-3">•</span>
                  <span>90-minute private session</span>
                </li>
                <li className="flex items-start">
                  <span className="text-amber-600 mr-3">•</span>
                  <span>Personalized 30-day action plan</span>
                </li>
                <li className="flex items-start">
                  <span className="text-amber-600 mr-3">•</span>
                  <span>Session recording</span>
                </li>
              </ul>
            </div>
            
            <p className="font-medium">
              This is the entry point for all work together.
            </p>
            
            <p className="text-base italic text-gray-600">
              This is not for you if you're not fun, don't believe in a higher power, or are only looking for transactional deals or shortcuts.
            </p>
            
            <p className="text-3xl font-bold text-gray-900 pt-4">
              Investment: $555
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-6 mb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Ready to book your Partnership Clarity Session?</h3>
            <p className="text-base text-gray-700 mb-4">
              Click the button below to complete payment via PayPal. Once your payment is received, you'll get an email from Brooke within 24-48 hours with available calendar times to schedule your session.
            </p>
            <p className="text-sm text-gray-600">
              You can pay with a PayPal account or credit/debit card (no PayPal account required).
            </p>
          </div>

          <div className="text-center">
            <a
              href="https://www.paypal.com/paypalme/brookeemery/555"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-semibold px-12 py-5 rounded-full text-xl transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Book Your Session
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
